import { Component, OnInit } from '@angular/core';
import { routerTransition } from 'app/shared/animations/router-transition.animation';
import { ConsultaEmailService } from './consulta-email.service';
import { PageService } from '../../shared/page.service';
import { Subject } from 'rxjs/Rx';
import { environment } from '../../../environments/environment';
import { RECAPTCHA_KEY } from 'app/config';

@Component({
  selector: 'cm-consulta-email',
  templateUrl: './consulta-email.component.html',
  styleUrls: ['./consulta-email.component.scss'],
  animations: [routerTransition],
})
export class ConsultaEmailComponent implements OnInit {
  public tipoUsuario;
  public matricula;
  public dtNascimento: string = '';
  public error = false;
  public CPD_MASK = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  public DT_MASK = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  public listaEmail;
  public environment = environment;
  public recaptchaKey = RECAPTCHA_KEY;
  public senha;
  public captchaStatus = false;
  situacaoModal = new Subject();

  constructor(private consultaEmailService:ConsultaEmailService,private page: PageService) {}
  
  ngOnInit() {
    if(this.environment.loginContexto!=='CEUMA'){
      window.location.href = '/';
    }
  }


  isDtNascimentoValida() {
    if (!this.dtNascimento || this.dtNascimento.length < 10) {
      return false;
    }

    try {
      const dateParts = this.dtNascimento.split('/');
      const dia = parseInt(dateParts[0], 10);
      const mes = parseInt(dateParts[1], 10);
      const ano = parseInt(dateParts[2], 10);
      const date = new Date(ano, mes - 1, dia);

      if (date.getFullYear() === ano
        && date.getMonth() + 1 === mes
        && date.getDate() === dia) {

        if (date > new Date()) {
          return false;
        }
        return true;
      }
    } catch (error) {
      // para pegar datas vazias ou nao completas, daria erro no split
      // quer dizer q nao é valida
    }
    return false;
  }
  
  disableBtnBuscar(){
    if(this.tipoUsuario!=undefined&&this.matricula!=undefined&&this.dtNascimento!=undefined&&this.isDtNascimentoValida())
      return false;
    return true;
  }
  
  acaoBuscar(){
    if(this.tipoUsuario!=undefined&&this.matricula!=undefined&&this.dtNascimento!=undefined&&this.isDtNascimentoValida()&&this.captchaStatus){
      let dataNascimento = this.dtNascimento.split("/");
      this.consultaEmailService.buscarEmail(this.tipoUsuario,this.matricula,`${dataNascimento[2]}-${dataNascimento[1]}-${dataNascimento[0]}`).subscribe(email=>{
        this.listaEmail = email;
        if(this.tipoUsuario==2){ /* Se for professor, preciso adicionar zeros à frente */
          this.senha = ('00'+this.matricula).substr(-6,6);
        }else{ /* Senão, deixo do jeito que está */
          this.senha = this.matricula;
        }
        this.mostrarModal(false);
      }, err=>{
        this.listaEmail = [];
        this.senha = undefined;
      });
    }
  }

  mostrarModal(status) {
    let situacao = !!status;
    this.situacaoModal.next(false);
    situacao ? this.page.mobile().lockScroll() : this.page.mobile().unlockScroll();
  }
  
  handleCaptcha($event) {
    this.captchaStatus = typeof $event === 'string' && $event.length > 10;
  }
}
